export const actions = {
  nuxtServerInit({dispatch}, {$auth}) {
    if ($auth.loggedIn) {
      dispatch('profileCompleteness/calculateProfileCompleteness');
    }
  },
};
